import Ac_qualificationsModel from '../Apis/Ac_qualifications.js'
import Controller from './Controller.js';

export default class Ac_qualificationsController extends Controller {

    constructor() {
        super(new Ac_qualificationsModel());
    }


}